import i18n from 'i18next'

// improvement proposal -- find a way to set the constants as strings instead of functions
// for that the translation function has to run AFTER i18n init has run
export const mandatoryField = () => i18n.t('error:mandatoryField')
export const invalidMailAddress = () => i18n.t('error:invalidMailAddress')
export const inputInvalid = () => i18n.t('error:inputInvalid')
export const invalidPhoneNumber = () => i18n.t('error:phoneErrorMessage')
export const invalidZip = () => i18n.t('error:zipErrorMessage')
export const invalidSerialNumber = () => i18n.t('error:serialNumberErrorMessage')
